import React, {useContext, useEffect, useState } from "react";
import { useSearchParams } from 'react-router-dom';
import { Col, Container, Row, Button, Offcanvas } from "react-bootstrap";
import { useMediaQuery } from 'react-responsive';
import Filter from '../Filter';
import '../FrontProductsBlock.css';
import './catpanel.css';
import ProductList from "../ProductList";
import {observer} from "mobx-react-lite";
import {Context} from "../..";
import { getProducts } from "../../http/productAPI";
import { FilterCircle } from "react-bootstrap-icons";
import Pagination from "./Pagination/Pagination";
import LoadMoreButton from "./Pagination/LoadMoreButton";



const SubCatalogList = observer(({ categories }) => {
  const { product } = useContext(Context);
  const { user } = useContext(Context);
  const [searchParams] = useSearchParams();
  const [filtersFromURLLoaded, setFiltersFromURLLoaded] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  
  const isMobile = useMediaQuery({ maxWidth: 600 });

  // 1. Парсим фильтры из URL
  useEffect(() => {
      const filtersFromURL = {};
      //    console.log ("product.pagination.page:",product.pagination.page,"           product.pagination.pageSize:",product.pagination.pageSize)
      for (const [key, value] of searchParams.entries()) {
        if (key.includes('[')) {
          const match = key.match(/^(.+?)\[(from|to)\]$/);
          if (match) {
            const [, name, field] = match;
            filtersFromURL[name] = {
              ...(filtersFromURL[name] || {}),
              [field]: value,
            };
          }
        } else if (key.endsWith('[]')) {
          const name = key.slice(0, -2);
          filtersFromURL[name] = [...(filtersFromURL[name] || []), value];
        } else {
          filtersFromURL[key] = [value];
        }
      }
    
      if (Object.keys(filtersFromURL).length > 0) {
        product.setSelectedFilters(filtersFromURL);
      }
      // важное!
      setFiltersFromURLLoaded(true);
  }, []);

  // 2. Загружаем продукты, только когда URL фильтры применены
  useEffect(() => {
      if (!filtersFromURLLoaded) return;
      const selectedFolderFilters = product.requestBodyFilter;
      getProducts(product.selectedFolder.id, product.pagination.page, product.pagination.pageSize, selectedFolderFilters)
        .then(data => {
          //console.log("Response from backend:", data);
            product.setProducts(data.products);
            product.setFilters(data.filters);
            product.setPagination({
               page: data.page,        // если бек возвращает с 0, а у тебя page с 1
               pageCount: data.pageCount,
               pageSize: data.pageSize
            });
        })
        .catch(error => {
            console.log("Ошибка при получении продуктов: SubCatalogList useEffect", error);
        });
  }, [
      filtersFromURLLoaded,
      product.search,
      product.selectedFolder,
      product.selectedFilters,
      product.reload,
      

  ]);
      //  product.pagination
      useEffect(() => {
      if (!filtersFromURLLoaded) return;
      const selectedFolderFilters = product.requestBodyFilter;
      getProducts(product.selectedFolder.id, product.pagination.page, product.pagination.pageSize, selectedFolderFilters)
        .then(data => {
          //console.log("Response from backend:", data);
            product.setProducts(data.products);
            product.setFilters(data.filters);
            product.setPagination({
               page: data.page,        // если бек возвращает с 0, а у тебя page с 1
               pageCount: data.pageCount,
               pageSize: data.pageSize
            });
        })
        .catch(error => {
            console.log("Ошибка при получении продуктов: SubCatalogList useEffect", error);
        });
  }, [product.selectedFilters,]);

  return (
    <Container className="mb-5">
      <Row>
        {!isMobile && (
          <Col xs={2} className="filter-sidebar">
            <Filter selectedFolderFilters={product.selectedFolderFilters} />
          </Col>
        )}

        <Col xs={12} md={10} className="px-0">
          {isMobile && (
            <div className="mobile-filters-button-wrapper">
              <Button variant="secondary" className="mobile-filters-button" onClick={() => setShowFilters(!showFilters)}>
                <FilterCircle className="me-2" size={24}/>
                {showFilters ? 'Применить фильтры' : 'Показать фильтры'}
              </Button>
            </div>
          )}

          <Container className="mb-4 products d-flex justify-content-start flex-wrap align-items-stretch px-0">
            <ProductList />
          </Container>

          {product.pagination.pageCount > 1 && <LoadMoreButton />}
          {product.pagination.pageCount > 1 && <Pagination />}

        </Col>
      </Row>

      {/* Мобильное отображение фильтров */}
      <Offcanvas show={showFilters} onHide={() => setShowFilters(false)} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Фильтры</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Filter selectedFolderFilters={product.selectedFolderFilters} />
        </Offcanvas.Body>
      </Offcanvas>
    </Container>
  );
});

export default SubCatalogList;